import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

const BooleanRadioGroup = <T extends FieldValues>({ control, name }: { control: Control<T>; name: Path<T> }) => {
  return (
    <Controller
      control={control}
      defaultValue={undefined}
      name={name}
      render={({ field }) => (
        <>
          <FormControl sx={{ alignItems: "center" }} fullWidth>
            <RadioGroup
              {...field}
              onChange={(e) => {
                field.onChange(e.target.value === "true" ? true : false);
              }}
              sx={{
                gap: 2,
              }}
              value={field.value === undefined || field.value === null ? "" : String(field.value)}
              row
            >
              <FormControlLabel control={<Radio />} label="Yes" value="true" />
              <FormControlLabel control={<Radio />} label="No" value="false" />
            </RadioGroup>
          </FormControl>
        </>
      )}
    />
  );
};

export default BooleanRadioGroup;
